import React, { Fragment, useEffect, useState } from "react";
import { Container, Row } from "reactstrap";
import { BarChart2 } from "react-feather";
import axios from "axios";
import config from "../../../../config";

import "../../../ControlPanel/sadmin.css";
import "../../Settings/settings.css";
import "./admin-dashboard.css";

import GreetingCard from "./GreetingCard";
import WidgetsWrapper from "./WidgetsWraper";
import SalesComparisonMom from "./SalesComparisonMom";
import YearOnYearTable from "./YearOnYearTable";
import MonthOnMonthTable from "./MonthOnMonthTable";
import TopFiveTenants from "./TopFiveTenants";
import Top5Categories from "./Top5Categories";
import TradeDensity from "./TradeDensity";
import DeliveryPartnerSales from "./DeliveryPartnerSales";
import RestaurantSales from "./RestaurantSales";
import SubcategorySales from "./SubcategorySales";
import Joyride from 'react-joyride';
import { useTranslation } from 'react-i18next';

const DashboardAdmin = () => {

  const { t } = useTranslation();
  const currentYear = new Date().getFullYear();
  const previousYear = currentYear - 1;
  const previousYear2 = currentYear - 2;
  const [properties, setProperties] = useState([]);
  const [selectedYear, setSelectedYear] = useState('');
  const [selectedMonth, setSelectedMonth] = useState('');
  const [selectedPropertyMallCode, setSelectedPropertyMallCode] = useState('');
  const [selectedPropertyId, setSelectedPropertyId] = useState('');
  const concessionaire_id = localStorage.getItem("concessionaireId");
  const property_id = localStorage.getItem("propertyAccess");
  const showGuideTour = localStorage.getItem("showGuideTour");

  const token = localStorage.getItem("sessiontoken");
  const configheader = {
    headers: {
      Authorization: `${token}`
    }
  };


  useEffect(() => {
    axios
      .post(`${config.hostname}/property/getpropertybyconcessionaire`, { property_concessionaire_id: concessionaire_id, property_id }, configheader)
      .then((response) => {
        setProperties(response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);


  const handleYearChange = (e) => {
    setSelectedYear(e.target.value)
    console.log('Selected Year:' + e.target.value);

  };

  const handleMonthChange = (e) => {
    setSelectedMonth(e.target.value)
  };


  const handlePropertyChange = (e) => {
    setSelectedPropertyMallCode(e.target.value)
    const selectedproperty = properties.filter(property => property.property_mall_code === e.target.value);
    const propertyId = selectedproperty._id
    setSelectedPropertyId(propertyId)
  };


  const tourSteps = [
    {
      target: '.filters-select', // Add class for year selection
      content: t('Select the filters to view the dashboard according to your preferences.'),
    },
    {
      target: '.widgets-wrapper', // Widgets wrapper
      content: t('This section provides key sales and revenue metrics.'),
    },
    {
      target: '.sales-comparison', // Sales Comparison
      content: t('Compare sales month-on-month for a quick performance overview.'),
    },
    {
      target: '.mom-comparison', // MOM Table
      content: t('Here is the month-on-month sales analysis to understand the percentage of growth compared to the previous month.'),
    },
    {
      target: '.yoy-comparison', // Year-on-Year Table
      content: t('View year-on-year comparisons to track long-term performance.'),
    },
    {
      target: '.category-sales', // Category Sales
      content: t('View sales by subcategory with filter options by category.'),
    },
    {
      target: '.top-tenants', // Top 5 Tenants
      content: t('See the top 5 tenants by sales or growth percentage.'),
    },
    {
      target: '.top-categories', // Top 5 Categories
      content: t('These are the top 5 categories by sales or growth percentage'),
    },
    {
      target: '.trading-density', // Trade Density
      content: t('This highlights the trend in trading density.'),
    },
    {
      target: '.fb-sales',
      content: t('This shows the dine-in and dine-out sales for F&B tenants.'),
    },
    {
      target: '.delivery-sales',
      content: t('Here, you can see the sales of each delivery partner.'),
    },

  ];


  return (
    <Fragment>
      {showGuideTour === "1" && (
        <Joyride
          steps={tourSteps}
          continuous
          showProgress
          showSkipButton
          styles={{
            options: {
              zIndex: 10000,
            },
          }}
        />
      )}
      <div className="v3-sadmin v3-admin-dash">
        <div className="v3-sadmin-hero">
          <div className="v3-sadmin-hero-text">
            <p className="v3-label" style={{ margin: 0 }}>{t('Sales dashboard')}</p>
            <h1 className="v3-display v3-sadmin-greeting">
              <span className="v3-sadmin-name">{t('Performance')}</span>
            </h1>
            <p className="v3-body v3-sadmin-sub">
              {t('Sales, revenue and tenant performance at a glance.')}{' '}
              <strong>{t('All values are in millions.')}</strong>
            </p>
          </div>
          <div className="v3-sadmin-hero-actions filters-select">
            <select className="v3-input v3-select" onChange={handleYearChange} aria-label={t('Year')}>
              <option value="">{t('Year — All')}</option>
              <option value={currentYear}>{currentYear}</option>
              <option value={previousYear}>{previousYear}</option>
              <option value={previousYear2}>{previousYear2}</option>
            </select>
            <select className="v3-input v3-select" onChange={handleMonthChange} aria-label={t('Month')}>
              <option value="">{t('Month — All')}</option>
              <option value="01">{t('January')}</option>
              <option value="02">{t('February')}</option>
              <option value="03">{t('March')}</option>
              <option value="04">{t('April')}</option>
              <option value="05">{t('May')}</option>
              <option value="06">{t('June')}</option>
              <option value="07">{t('July')}</option>
              <option value="08">{t('August')}</option>
              <option value="09">{t('September')}</option>
              <option value="10">{t('October')}</option>
              <option value="11">{t('November')}</option>
              <option value="12">{t('December')}</option>
            </select>
            <select className="v3-input v3-select" onChange={handlePropertyChange} aria-label={t('Property')}>
              <option value="">{t('Property — All')}</option>
              {properties.map((property) => (
                <option key={property.property_mall_code} value={property.property_mall_code}>
                  {property.property_name}
                </option>
              ))}
            </select>
            <span className="v3-sadmin-kpi-icon accent" aria-hidden>
              <BarChart2 size={18} />
            </span>
          </div>
        </div>

        <Container fluid={true} className="p-0">
          <Row className="widget-grid">
            <GreetingCard />
          <WidgetsWrapper year={selectedYear} month={selectedMonth} propertyMallCode={selectedPropertyMallCode} propertyId={selectedPropertyId} className='widgets-wrapper' />
          <div className="sales-comparison">
            <SalesComparisonMom year={selectedYear} propertyMallCode={selectedPropertyMallCode} />
          </div>
          <div className="mom-comparison">
            <MonthOnMonthTable year={selectedYear} propertyMallCode={selectedPropertyMallCode} />
          </div>
          <YearOnYearTable year={selectedYear} propertyMallCode={selectedPropertyMallCode} className={'yoy-comparison'} />
          <SubcategorySales year={selectedYear} month={selectedMonth} propertyMallCode={selectedPropertyMallCode} className={'category-sales'} />
          <TopFiveTenants year={selectedYear} month={selectedMonth} propertyMallCode={selectedPropertyMallCode} className="top-tenants" />
          <Top5Categories year={selectedYear} month={selectedMonth} propertyMallCode={selectedPropertyMallCode} className="top-categories" />
          <div className="trading-density">
            <TradeDensity year={selectedYear} propertyMallCode={selectedPropertyMallCode} />
          </div>
          <RestaurantSales year={selectedYear} month={selectedMonth} propertyMallCode={selectedPropertyMallCode} className='fb-sales' />
          <DeliveryPartnerSales year={selectedYear} month={selectedMonth} propertyMallCode={selectedPropertyMallCode} className='delivery-sales' />
          </Row>
        </Container>
      </div>
    </Fragment>
  );
};

export default DashboardAdmin;
